import { render } from "./SetupAndTradeSteps.vue?vue&type=template&id=2ab68cdf&scoped=true"
import script from "./SetupAndTradeSteps.vue?vue&type=script&lang=js"
export * from "./SetupAndTradeSteps.vue?vue&type=script&lang=js"

import "./SetupAndTradeSteps.vue?vue&type=style&index=0&id=2ab68cdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab68cdf"]])

export default __exports__